module.exports = __webpack_public_path__ + "img/premium.b4397f83.png";